import React from "react";

export default function UxToggle({
  labelText,
  checked,
  handleClick,
  isDisabled,
  inverse = false,
  style = {},
}) {
  return (
    <div
      className="ux-toggle-container"
      style={{ ...style, ...(isDisabled && { pointerEvents: "none" }) }}
    >
      {!inverse && (
        <label className="ux-toggle-switch">
          <input type="checkbox" checked={checked} onChange={handleClick} />
          <div className="ux-toggle-slider" />
        </label>
      )}
      <span
        className={isDisabled ? "ux-toggle-label-disabled" : "ux-toggle-label"}
        style={inverse ? { marginRight: 7 } : {}}
      >
        {labelText}
      </span>
      {inverse && (
        <label className="ux-toggle-switch">
          <input type="checkbox" checked={checked} onChange={handleClick} />
          <div className="ux-toggle-slider" />
        </label>
      )}
    </div>
  );
}
